import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* MainLayout */
// import MainLayout from '@/layout/main/index.vue'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/user/login')
  },
  {
    path: '/rep-login',
    name: 'RepLogin',
    meta: {
      title: '代理登录'
    },
    component: () => import('@/views/user/repLogin')
  },
  {
    path: '/login-wx/:uid/:args?',
    name: 'LoginWx',
    meta: {
      title: '微信登录'
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/loginWx.vue')
  },
  {
    path: '/login-wx-redirect/:uid',
    name: 'LoginWxRedirect',
    meta: {
      title: '微信登录跳转'
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/loginWxRedirect.vue')
  },
  {
    path: '/bind-wechat',
    name: 'BindWechat',
    meta: {
      title: '微信绑定'
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/bindWechat.vue')
  },
  {
    path: '/bind-wx/:uid',
    name: 'BindWx',
    meta: {
      title: '微信绑定'
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/bindWx.vue')
  },
  {
    path: '/bind-wx-redirect/:uid',
    name: 'BindWxRedirect',
    meta: {
      title: '微信绑定跳转'
    },
    component: () => import(/* webpackChunkName: "about" */ '@/views/user/bindWxRedirect.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: {
      title: '注册'
    },
    component: () => import('@/views/user/register')
  },

  {
    path: '/reset-password',
    name: 'ResetPassword',
    meta: {
      title: '重置密码'
    },
    component: () => import('@/views/user/resetPassword')
  },

  {
    path: '/user/org/:id',
    name: 'UserOrg', // org的member
    meta: {
      title: '工作区成员'
    },
    component: () => import('@/views/user/org')
  },

  {
    path: '/user/setting',
    name: 'UserSetting',
    meta: {
      title: '账号设置'
    },
    component: () => import('@/views/user/setting')
  },

  {
    path: '/order/create',
    name: 'OrderCreate',
    meta: {
      title: '创建订单'
    },
    component: () => import('@/views/order/create')
  },

  {
    path: '/order/create_sms',
    name: 'OrderCreateSms',
    meta: {
      title: '创建短信增购订单'
    },
    component: () => import('@/views/order/createSms')
  },

  {
    path: '/order/org/:id',
    name: 'OrderOrg',
    meta: {
      title: '工作区订单',
      isBack: false
    },
    component: () => import('@/views/order/org')
  },

  {
    path: '/order/:id/view',
    name: 'OrderView',
    meta: {
      title: '订单详情'
    },
    component: () => import('@/views/order/view')
  },
  {
    path: '/order/wxpay-qrcode',
    name: 'WxpayQrcode',
    meta: {
      title: '微信支付'
    },
    component: () => import('@/views/order/wxpayQrcode')
  },
  {
    path: '/order/wxpay-qrcode2',
    name: 'WxpayQrcode2',
    meta: {
      title: '微信支付'
    },
    component: () => import('@/views/order/wxpayQrcode2')
  },
  {
    path: '/',
    name: 'Home',
    redirect: () => {
      const orgId = localStorage.getItem('bd_webapp_orgId')
      if (orgId) {
        return {
          name: 'FormOrgMe',
          params: { id: orgId }
        }
      }

      return { name: 'OrgMe' }
    }
  },

  {
    path: '/form/org/:id/me',
    name: 'FormOrgMe',
    meta: {
      title: '我的表单',
      isBack: false
    },
    component: () => import('@/views/form/orgMe')
  },
  {
    path: '/form/org/:id/co',
    name: 'FormOrgCo',
    meta: {
      title: '协管表单',
      isBack: false
    },
    component: () => import('@/views/form/orgCo')
  },
  {
    path: '/form/org/:id/admin',
    name: 'FormOrgAdmin',
    meta: {
      title: '全部表单',
      isBack: false
    },
    component: () => import('@/views/form/orgAdmin')
  },
  {
    path: '/form/me/co',
    name: 'FormMeCo',
    meta: {
      title: '外部协管表单'
    },
    component: () => import('@/views/form/meCo')
  },
  {
    path: '/form/create',
    name: 'FormCreate',
    meta: {
      title: '创建表单'
    },
    component: () => import('@/views/form/create')
  },
  {
    path: '/form/:id/update',
    name: 'FormUpdate',
    meta: {
      title: '编辑表单'
    },
    component: () => import('@/views/form/update')
  },
  {
    path: '/form/:id/edit',
    name: 'FormEdit',
    meta: {
      title: '表单编辑'
    },
    component: () => import('@/views/form/edit')
  },

  {
    path: '/form/:id/setting',
    name: 'FormSetting',
    meta: {
      title: '表单设置'
    },
    component: () => import('@/views/form/setting')
  },
  {
    path: '/form/:id/publish',
    name: 'FormPublish',
    meta: {
      title: '表单发布'
    },
    component: () => import('@/views/form/publish')
  },
  {
    path: '/form/:id/reply-list',
    name: 'FormReplyList',
    meta: {
      title: '表单数据'
    },
    component: () => import('@/views/form/replyList')
  },
  {
    path: '/form/:id/reply-stat',
    name: 'FormReplyStat',
    meta: {
      title: '表单数据统计'
    },
    component: () => import('@/views/form/replyStat')
  },
  {
    path: '/form/:id/reply-overview',
    name: 'FormReplyOverview',
    meta: {
      title: '表单数据概况'
    },
    component: () => import('@/views/form/replyOverview')
  },

  {
    path: '/reply/me',
    name: 'ReplyMe',
    meta: {
      title: '我的答复'
    },
    component: () => import('@/views/reply/me')
  },
  {
    path: '/reply/:id/verify',
    name: 'ReplyVerify',
    meta: {
      title: '答复核销'
    },
    component: () => import('@/views/reply/verify')
  },
  {
    path: '/contact/me',
    name: 'ContactMe',
    meta: {
      title: '我的联系人'
    },
    component: () => import('@/views/contact/me')
  },
  // {
  //   path: '/tpl/list',
  //   name: 'TplList',
  //   meta: {
  //     title: '模板'
  //   },
  //   component: () => import('@/views/tpl/list')
  // },
  {
    path: '/tpl/list',
    name: 'TplList',
    meta: {
      title: '模板'
    },
    component: () => import('@/views/tpl/list2')
  },
  {
    path: '/org/me',
    name: 'OrgMe',
    meta: {
      title: '我的工作区'
    },
    component: () => import('@/views/org/me')
  },

  {
    path: '/org/:id/setting',
    name: 'OrgSetting',
    meta: {
      title: '关于工作区'
    },
    component: () => import('@/views/org/setting')
  },
  {
    path: '/file/org/:id/:menu',
    name: 'FileOrg',
    meta: {
      title: '素材'
    },
    component: () => import('@/views/file/org')
  },
  {
    path: '/payware/spu/:id/view',
    name: 'PwSpuView',
    meta: {
      // title: '软件详情'
    },
    component: () => import('@/views/payware/spuView')
  },
  {
    path: '/payware/order/:id/view',
    name: 'PwOrderView',
    meta: {
      // title: '软件详情'
    },
    component: () => import('@/views/payware/orderView')
  },
  {
    path: '/payware/order/me',
    name: 'PwOrderMe',
    meta: {
      // title: '软件详情'
    },
    component: () => import('@/views/payware/orderMe')
  },
  {
    path: '/payware/order/wxpay-qrcode',
    name: 'PwWxpayQrcode',
    meta: {
      title: '微信支付'
    },
    component: () => import('@/views/payware/wxpayQrcode')
  },
  {
    path: '/result',
    meta: {
      title: '结果页'
    },
    component: () => import('@/views/result')
  },

  {
    path: '/404',
    meta: {
      title: '404'
    },
    component: () => import('@/views/404')
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  base: process.env.VUE_APP_WEBAPP_BASE_PATH,
  mode: 'history', // require service support
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // reset router
// }

export default router
